import { useEffect, useState } from 'react';
import styles from './MapMobileButton.module.scss';
import Typography from '@/components/UI/typography/Typography';
import Icon from '@/components/UI/icon/Icon';
import Box from '@/components/UI/box/Box';
interface MapMobileButtonProps {
  isShowMap: boolean;
  onToggle: () => void;
  showDownloadBanner: boolean;
}
const MapMobileButton = ({
  isShowMap,
  showDownloadBanner,
  onToggle
}: MapMobileButtonProps) => {
  const [isDownloadBanner, setIsDownloadBanner] = useState(false);
  useEffect(() => {
    if (sessionStorage.getItem('show-download-banner')) {
      setIsDownloadBanner(false);
    } else {
      setIsDownloadBanner(true);
    }
  }, [showDownloadBanner]);
  return <Box className={`${styles['button']} ${isDownloadBanner ? styles['has-banner'] : ''}`} onClick={onToggle} data-sentry-element="Box" data-sentry-component="MapMobileButton" data-sentry-source-file="MapMobileButton.tsx">
      <Icon size={'xSmall'} name={isShowMap ? 'row-vertical' : 'location'} type={'white'} data-sentry-element="Icon" data-sentry-source-file="MapMobileButton.tsx" />
      <Typography variant={'bodyM'} data-sentry-element="Typography" data-sentry-source-file="MapMobileButton.tsx">{isShowMap ? 'لیست' : 'نقشه'}</Typography>
    </Box>;
};
export default MapMobileButton;